import { render, staticRenderFns } from "./LoanList.vue?vue&type=template&id=dadd072a&scoped=true&"
import script from "./LoanList.vue?vue&type=script&lang=js&"
export * from "./LoanList.vue?vue&type=script&lang=js&"
import style0 from "./LoanList.vue?vue&type=style&index=0&id=dadd072a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadd072a",
  null
  
)

export default component.exports